import { LeadSourcesSettingsLocation } from "@sp-crm/core";
import { useQuery } from "@tanstack/react-query";
import { trpc } from "components/rpc/trpc";
import { stableQueryOptionsRpc } from "util/requests";

export type LeadSourcesSettingsLocationState = LeadSourcesSettingsLocation | "loading";

export const useLeadSourcesSettingsLocation = (): LeadSourcesSettingsLocationState => {
    const trpcClient = trpc.useTRPC();
    const { data, isError } = useQuery({
        ...trpcClient.inboundLeadSource.settingsLocation.queryOptions(),
        ...stableQueryOptionsRpc(),
    });
    if (data) {
        return data;
    }
    return isError ? "agency" : "loading";
};
